module.exports = __webpack_public_path__ + "static/ms-icon-310x310-d49fbf9e8bbde69a54ebeff96ed440fe.png";